function validatePassword( password ) {
	// check the length of the password
	let test = /^.{8,}$/;

	if ( !test.test( password ) ) {
		return false;
	}

	// check for one uppercase letter
	test = /(.*[A-Z]+.*)$/;

	if ( !test.test( password ) ) {
		return false;
	}

	// check for one lowercase letter
	test = /(.*[a-z]+.*)$/;

	if ( !test.test( password ) ) {
		return false;
	}

	// check for one numeric digit
	test = /(.*[0-9]+.*)$/;

	if ( !test.test( password ) ) {
		return false;
	}

	// check for one special character
	test = /(.*[`~!@#$%^&*()_=+[\]{}\\|;:’“,<.>/?-]+.*)$/;

	if ( !test.test( password ) ) {
		return false;
	}

	return true;
}

export default validatePassword;
